import React from "react";
import { createRoot } from "react-dom/client";
import FaqsPageIsland from "./FaqsPageIsland";

const mountNode = document.getElementById("faqs-page-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<FaqsPageIsland config={config} />);
  }
}
